import React, { useEffect, useRef, useState } from 'react';
import Typed from 'typed.js';
const HomePage = () => {
    const burger = useRef();
    const burgerMenu = useRef();
    const title = useRef();
    const [isMobile, setIsMobile] = useState(window.innerWidth < 1200);

    useEffect(()=>{
        const handleResize = () => {
            setIsMobile(window.innerWidth < 1200);
        };

        window.addEventListener("resize", handleResize);


        const typed = new Typed(title.current, {
            strings: isMobile ? ["Section Web Dev"] : ["BES web developer", "Section Web Dev"],
            typeSpeed: 100,
            showCursor: false
        });

        return () => {
            // Destroy Typed instance during cleanup to stop animation
            typed.destroy();
        };
    },[])

    const handleClickBurger = () => {
        burger.current.classList.toggle('open')
        burgerMenu.current.classList.toggle('open')
        burgerMenu.current.children[0].children[0].childNodes.forEach(element => {
            element.addEventListener('click',()=>{
                burger.current.classList.remove('open')
                burgerMenu.current.classList.remove('open')
            })
        });
    }

    return ( 
        <div className='slide' id='home'>
            <header>
                <div id="container-logo">
                    <div className="wrapper-gradient">
                        <a href="https://www.epse.be" target='_blank' id="logo">
                            <img src="/images/LogoEAE2.svg" alt="Logo EPSE" />
                        </a>
                    </div>
                </div>
                <nav>
                    <ul>
                        <li><a href="#presentation">Présentation</a></li>
                        <li><a href="#skills">Programme</a></li>
                        <li><a href="#testeur">Initiation</a></li>
                        <li><a href="#avis">Avis</a></li>
                        <li><a href="#contact">Contact</a></li>
                    </ul>
                </nav>
                <div id="container-moodle">
                    {/*<a href="https://moodle.myepse.be" target='_blank' id="moodle">
                        <img src="/images/Moodle.svg" alt="Moodle Logo" />
                    </a>*/}
                </div>
                <div id="burger" ref={burger} onClick={handleClickBurger}>
                    <div className="bar"></div>
                    <div className="bar"></div>
                    <div className="bar"></div>
                </div>
            </header>
            <div id="burger-menu" ref={burgerMenu}>
                <nav>
                    <ul>
                        <li><a href="#presentation">Présentation</a></li>
                        <li><a href="#skills">Programme</a></li>
                        <li><a href="#testeur">Initiation</a></li>
                        <li><a href="#avis">Avis</a></li>
                        <li><a href="#contact">Contact</a></li>
                    </ul>
                </nav>
            </div>
            <div className="wrapper">
                <div id="intro">
                    <div id="intro-title">
                        <h1 ref={title} />
                    </div>
                    <h2>Enseignement pour adultes d'Enghien</h2>
                    <h3>Apprends à coder, crée ton avenir grâce à notre formation unique</h3>
                    <div id="promise">
                        <div className="stat">
                            <div className="title">Début</div>
                            <div className="value">Septembre 2025</div>
                        </div>
                        <div className="stat">
                            <div className="title">Durée</div>
                            <div className="value">2 ans</div>
                        </div>
                        <div className="stat">
                            <div className="title">Prerequis</div>
                            <div className="value">Aucun</div>
                        </div>
                    </div>
                    <a className="button rejoindre" href="https://www.epse.be/inscription" target='_blank'>
                        Rejoins-nous
                    </a>
                </div>
                <div id="social">
                    <a href="https://www.instagram.com/e.p.s.e/" target='_blank'>
                        <img src="/images/socials/insta.svg" alt="Instagram" />
                    </a>
                    <a href="https://www.tiktok.com/@e.p.s.e" target='_blank'>
                        <img src="/images/socials/tiktok.svg" alt="Tik Tok" />
                    </a>
                    <a href="https://www.facebook.com/EPSEMarcq/" target='_blank'>
                        <img src="/images/socials/facebook.svg" alt="Facebook" />
                    </a>
                    <a href="https://www.youtube.com/channel/UC33Fs4BdaHlEb5GfDoZzSsA?view_as=subscriber" target='_blank'>
                        <img src="/images/socials/youtube.svg" alt="YouTube" />
                    </a>
                    <a href="https://www.linkedin.com/school/epse/" target='_blank'>
                        <img src="/images/socials/linked.svg" alt="Linkedin" />
                    </a>
                </div>

                <div id="devSkills">
                    <img src="/images/skills/Symfony.svg" alt="Symfony" title="Symfony" />
                    <img src="/images/skills/React.svg" alt="ReactJs" title="ReactJS" />
                    <img src="/images/skills/NextJS.svg" alt="NextJS" title="NextJS" />
                    <img src="/images/skills/CSS.svg" alt="CSS3" title="CSS3" />
                    <img src="/images/skills/HTML.svg" alt="HTML5" title="HTML5" />
                    <img src="/images/skills/Sass.svg" alt="SASS" title="SASS" />
                    <img src="/images/skills/Python.svg" alt="Python" title="Python" />
                    <img src="/images/skills/PHP.svg" alt="PHP" title="PHP" />
                    <img src="/images/skills/JS.svg" alt="JavaScript" title="JavaScript" />
                </div>

            </div>
        </div>
     );
}
 
export default HomePage;